module.exports = __webpack_public_path__ + "img/50.1cfabce0.jpg";